import aspida from '@aspida/axios';
import axios from 'axios';

import api from '@api/$api';

const axiosConfig = { 
  baseURL: '/',
  withCredentials: true
}

export const apiClient = api(aspida(axios, axiosConfig))
